import { createContext, useContext, useState, ReactNode, useEffect } from "react";
import { SettingsService, MenuSettings } from "../service/settings.service";
import { AuthService } from "../service/auth.service";

interface MenuContextType {
  menuSettings: MenuSettings;
  isLoading: boolean;
  loadMenu: () => Promise<void>;
  hasAccess: (path: string) => boolean;
}

const MenuContext = createContext<MenuContextType | undefined>(undefined);

export function MenuProvider({ children }: { children: ReactNode }) {
  const [menuSettings, setMenuSettings] = useState<MenuSettings>({
    modules: []
  });

  const [isLoading, setIsLoading] = useState(false);

  const loadMenu = async () => {
    setIsLoading(true);
    try {
      const settings = await SettingsService.getMenuSettings();
      setMenuSettings(settings);
    } catch (error) {
      console.error("Failed to fetch menu settings:", error);
    } finally {
      setIsLoading(false);
    }
  };

    const hasAccess = (key: string): boolean => {
    return menuSettings.dashboard?.some(m => m.key === key) ?? false;
    };

  useEffect(() => {
    const token = AuthService.getToken();

    if (token) {
      loadMenu();
    }
  }, []);

  return (
    <MenuContext.Provider
      value={{
        menuSettings,
        isLoading,
        loadMenu,
        hasAccess,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
}

export function useMenu() {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error("useMenu must be used within MenuProvider");
  }
  return context;
}
